import http from "../../http-common";
import authHeader from "../../services/authHeader";
import { JOB_ORDER_API } from "../../api";


export const createJobOrder = (data) => {
    console.log('calling')
    return http.post(`${JOB_ORDER_API}`, data, {
        headers: authHeader(),
    });
}

export const getAllJobOrders = () => {
    return http.get(`${JOB_ORDER_API}`, {
        headers: authHeader(),
    });
}

//this function will update the candidate status on job order
export const createJobOrderCandidate = (data) => {
    return http.post(`${JOB_ORDER_API}/candidate/1`, data, {
        headers: authHeader(),
    });
}

export const updateJobOrderCandidate = (id, data) => {
    return http.put(`${JOB_ORDER_API}/candidate/${id}`, data, {
        headers: authHeader(),
    });
}

export const updateJobOrder = (id, data) => {
    return http.put(`${JOB_ORDER_API}/${id}`, data, {
        headers: authHeader(),
    });
}
